import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { KryptonElement } from "./krypton-element";
import { ContextMenu } from './menu-context';
import { PropertyValues } from "@lit/reactive-element";

export class ModuleHeader extends KryptonElement {

    static DEFAULT_KEY = 'Security.showPopupContextMenu';

    static styles = css`
        :host {
            height: var(--module-header-height);
            width: 100%;
            z-index: var(--z-index-module-header);
            display:block;
            top: var(--header-height);
        }
        :host(.disabled) {
            display: none;
        }
        .module-header {
            display: -ms-grid;
            display: grid;
            -ms-grid-columns: auto auto;
            grid-template-columns: auto auto;
            grid-template-areas: "title nav";
            align-items: center;
            color: var(--krypton-font-color-header);
            background-color: var(--krypton-color-grey);
            padding: 0 1.5rem;
            margin: 0 0 0.25em 0;
            overflow: visible;
            height: var(--module-header-height);
            box-sizing: border-box;
            width: 100%;
            max-width: 100vw;
            z-index: var(--z-index-module-header);
            position: fixed;
        }
        .module-header.shrink{
            top: 1.25rem !important;
        }

        #title {
            grid-area: title;
            -ms-grid-row: 1;
            -ms-grid-column: 1;
            grid-row: 1;
            grid-column: 1;
            justify-content: flex-start;
            line-height: 0.9em;
            margin-top: auto;
            margin-bottom: auto;
        }

        #nav {
            grid-area: nav;
            -ms-grid-row: 1;
            -ms-grid-column: 2;
            grid-row: 1;
            grid-column: 2;
            display: flex;
            justify-content: flex-end;
            padding-right: 10px;
        }

        #main {
            padding: 1em 1.5em;
        }

        .context-menu-item {
            display: flex;
            justify-content: center;
            margin: 0.5em;
            border: 1px black solid;
            background-color: red;
            height: 24px;
            width: 24px;
        }
        @media only screen and (min-width: 544px) and (max-width: 768px){
            #title {
                font-size: 3vw;
            }
            .module-header{
                box-shadow: 1px 1px 3px #666666;
            }
        }
        @media only screen and (max-width: 543px){
            #title {
                display: none;
            }
            .module-header{
                box-shadow: 1px 1px 3px #666666;
            }
        }
    `;
    constructor() {
        super();

        this.module = "";
        this.moduleTitle = "";
        //initialize key to default
        this.key = ModuleHeader.DEFAULT_KEY;
    }

    render() {
        return html`
            <div class="module-header">
                <h1 id="title">${this.moduleTitle}</h1>
                <nav id="nav">
                    <slot name="context-menu"></slot>
                </nav>
            </div>
        `;
    }

    _moduleTitle;
    get moduleTitle() {
        if (!this._moduleTitle) {
            let p = this.closest("page-element") as any; //current page-element
            p = p?.opener;
            while (p && !p.moduleTitle) p = p?.opener;
            if (p?.moduleTitle){
                this._moduleTitle = p?.moduleTitle;
                this.moduleTitle = p?.moduleTitle;
            }
        }
        return this._moduleTitle;
    }

    @property({ type: String, attribute: "module-title", reflect: true })
    set moduleTitle(moduleTitle) {
        const oldValue = this._moduleTitle;
        this._moduleTitle = moduleTitle;
        this.classList[this._moduleTitle ? "remove" : "add"]("disabled");
        this.requestUpdate("moduleTitle", oldValue);
    }


    _module;
    get module() {
        if (!this._module) {
            let p = this.closest("page-element") as any; //current page-element
            p = p?.opener;
            while (p && !p.module) p = p?.opener;
            if (p?.module){
                this._module = p?.module;
                this.module = p?.module;
            }
        }
        return this._module;
    }

    @property({ type: String, attribute: "module", reflect: true })
    set module(module) {
        const oldValue = this._module;
        this._module = module;
        this.requestUpdate("module", oldValue);
    }


    _key;
    get key() {
        return this._key;
    }

    @property({ type: String, attribute: "key", reflect: true })
    set key(key) {
        const oldValue = this._key;
        this._key = key;
        this.requestUpdate("key", oldValue);
    }

    _contextMenu;
    get contextMenu() {
        return this._contextMenu;
    }

    @property({ type: ContextMenu, reflect: false, converter: {} })
    set contextMenu(contextMenu) {
        const oldValue = this._contextMenu;
        this._contextMenu = contextMenu;
        //remove existing, if any
        for (let s of this.querySelectorAll("menu-context")) {
            this.removeChild(s);
        }
        //add
        for (let cm of contextMenu) {
            this.appendChild(cm);
        }
        this.requestUpdate("context-menu", oldValue);
    }

    async fetchContextMenu(key) {
        this.contextMenu = await this.kryptonApp().fetchContextMenu(key ? key : ModuleHeader.DEFAULT_KEY);
    }

    updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('key'))
            this.fetchContextMenu(this.key);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'module-header': ModuleHeader;
    }
}
